/**
 * GruposLinks + Links anidados (igual que Listas + Secuencias).
 * Al hacer clic en "Ver links" de un grupo, muestra los links de ese grupo.
 */
import { useCallback, useEffect, useState } from 'react';
import CrudPage from './shared/CrudPage';
import {
  adminGet, adminPost, adminPut, adminDelete, getLenguajes, uploadAdminFile,
} from '../../api/adminClient';

export default function AdminLinks() {
  const [lenguajeOpts, setLenguajeOpts] = useState([]);
  const [selectedGrupo, setSelectedGrupo] = useState(null);

  useEffect(() => {
    getLenguajes()
      .then((rows) => setLenguajeOpts(rows.map((l) => ({ value: l.ID, label: l.Descripcion }))))
      .catch(() => {});
  }, []);

  if (selectedGrupo) {
    return <LinksPage grupo={selectedGrupo} onBack={() => setSelectedGrupo(null)} />;
  }

  return (
    <CrudPage
      title="Grupos de links"
      idKey="ID"
      columns={[
        { key: 'ID',          label: 'ID' },
        { key: 'lenguaje',    label: 'Acceso' },
        { key: 'Descripcion', label: 'Descripción', primary: true },
      ]}
      fields={[
        { key: 'id_lenguaje', label: 'Acceso', type: 'select', options: lenguajeOpts, required: true },
        { key: 'Descripcion', label: 'Descripción', required: true },
      ]}
      fetchAll={() => adminGet('/api/admin/grupos-links')}
      onCreate={(d) => adminPost('/api/admin/grupos-links', d)}
      onUpdate={(id, d) => adminPut(`/api/admin/grupos-links/${id}`, d)}
      onDelete={(id) => adminDelete(`/api/admin/grupos-links/${id}`)}
      actions={[{ label: 'Ver links', onClick: (row) => setSelectedGrupo(row) }]}
    />
  );
}

function LinksPage({ grupo, onBack }) {
  const fetchAll = useCallback(
    () => adminGet(`/api/admin/grupos-links/${grupo.ID}/links`),
    [grupo.ID],
  );
  const onCreate = useCallback(
    (d) => adminPost(`/api/admin/grupos-links/${grupo.ID}/links`, d),
    [grupo.ID],
  );

  return (
    <div className="h-full flex flex-col">
      <div className="flex-shrink-0 px-6 pt-6 pb-0">
        <button
          onClick={onBack}
          className="text-sm text-violet-600 hover:text-violet-800 bg-transparent border-0 cursor-pointer mb-2"
        >
          ← Volver a grupos
        </button>
      </div>
      <div className="flex-1 min-h-0">
        <CrudPage
          title={`Links — ${grupo.Descripcion}`}
          idKey="ID"
          columns={[
            { key: 'ID', label: 'ID' },
            {
              key: 'rutaImagen',
              label: 'Icono',
              render: (v) => v
                ? <img src={v} alt="" className="w-9 h-9 rounded-lg object-cover border border-slate-200" />
                : <span className="text-slate-300 text-xs">—</span>,
            },
            { key: 'Titulo',      label: 'Título', primary: true },
            { key: 'Descripcion', label: 'Descripción' },
            { key: 'Link',        label: 'URL' },
          ]}
          fields={[
            { key: 'Titulo',      label: 'Título',      required: true },
            { key: 'Descripcion', label: 'Descripción', type: 'textarea' },
            { key: 'Link',        label: 'URL',          required: true },
            {
              key: 'rutaImagen',
              label: 'Icono',
              type: 'image',
              onUpload: (file) => uploadAdminFile(file, 'links'),
              hint: (row) => (row?.ID ? `k_${row.ID}.png` : null),
            },
          ]}
          fetchAll={fetchAll}
          onCreate={onCreate}
          onUpdate={(id, d) => adminPut(`/api/admin/links/${id}`, d)}
          onDelete={(id) => adminDelete(`/api/admin/links/${id}`)}
        />
      </div>
    </div>
  );
}
